import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
    Button,
    Col,
    ControlLabel,
    Form,
    FormGroup,
    Panel,
    PanelGroup
} from 'react-bootstrap'
import { Link } from 'react-router'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import DatePicker from 'react-bootstrap-date-picker'
import Loadable from 'react-loading-overlay'

@observer(['activities', 'companies', 'organizations', 'partners', 'globals'])
export default class ActivityReport extends Component {

    constructor(props) {
        super(props)

        this.state = {
            startDate: '',
            endDate: '',
            loadableState: false
        }
    }

    componentDidMount() {
        if (this.props.activities.data.length > 0 && (this.state.startDate == '' || this.state.endDate == '')) {
            this.props.activities.resetActivityDate()
        }
    }

// FORM VALIDATION FUNCTIONS
    validateReportForm() {
        if (this.getStartDateValidationState() == 'error') {
            return false
        }

        if (this.getEndDateValidationState() == 'error') {
            return false
        }

        return true
    }

    getStartDateValidationState() {
        if (this.state && this.state.startDate != '') {
            return 'success'
        } else {
            return 'error'
        }
    }

    getEndDateValidationState() {
        if (this.state && this.state.endDate != 0) {
            return 'success'
        } else {
            return 'error'
        }
    }

//STATE CHANGE FUNCTIONS
    onStartDateChanged(value, formattedValue) {
        console.log('V: ', value);
        console.log('FV: ', formattedValue);
        if (formattedValue == null) {
            formattedValue = ''
        }

        this.setState({
            startDate: formattedValue
        })
    }

    onEndDateChanged(value, formattedValue) {
        console.log('V: ', value);
        console.log('FV: ', formattedValue);
        if (formattedValue == null) {
        formattedValue = ''
        }

        this.setState({
            endDate: formattedValue
        })
    }

//PROCESSING FUNCTIONS
    runActivityReport() {
        this.setState({
            loadableState: true
        })

        if (this.validateReportForm()) {
            this.props.activities.loadAllActivityByDateRange(this.state.startDate, this.state.endDate, (activities) => {

                let promises = []

                let p1 = new Promise((resolve, reject) => {
                    this.props.companies.loadAllCompanies((data) => {
                        resolve(data)
                    })
                })
                
                let p2 = new Promise((resolve, reject) => {
                    this.props.organizations.loadAllOrganizations((data) => {
                        resolve(data)
                    })
                })

                let p3 = new Promise((resolve, reject) => {
                    this.props.partners.loadAllOrganizationPartners(this.props.globals.loggedInUser.organizationId, (data) => {
                        resolve(data)
                    })
                })

                promises.push(p1);
                promises.push(p2);
                promises.push(p3);

                Promise.all(promises).then((results) => {
                    const companies = results[0];
                    const organizations = results[1];
                    const partners = results[2];                    

                    for ( let i = 0; i < activities.length; i++ ) {

                        // Sections: 1 = Quote, 2 = Task, 3 = Notes, 4 = Company, 5 = Partner
                        switch (activities[i].activitySectionTypeId) {
                            case 4:
                                companies.map((company) => {
                                    if ( activities[i].activitySectionId == company.id ) {
                                        activities[i].activitySectionName = company.name
                                    }
                                })
                            break
                            case 5:
                                partners.map((partner) => {
                                    if ( activities[i].activitySectionId == partner.id ) {
                                        activities[i].activitySectionName = partner.name
                                    }
                                })
                            break
                            default:
                                activities[i].activitySectionName = activities[i].activitySectionId
                            break
                        }

                        // Entities: 1 = Company, 2 = Partner, 3 = Organization
                        switch (activities[i].entityTypeId) {
                            case 1:
                                companies.map((company) => {
                                    if ( activities[i].entityId == company.id ) {
                                        activities[i].entityName = company.name
                                    }
                                })
                                break
                            case 2:
                                partners.map((partner) => {
                                    if ( activities[i].entityId == partner.id ) {
                                        activities[i].entityName = partner.name
                                    }
                                })
                            break
                            case 3:
                                activities[i].entityName = 'GPS Leaders'
                            break
                        }
                    }

                    this.setState({
                        loadableState: false
                    })
                })
            })
        }
        else {
            alert('Please check the form.  Required data is missing.')
            this.setState({
                loadableState: false
            })
        }
    }

    formatSectionLink(cell, row) {
        let formatSectionLink = 'Loading...'

        if (cell) {
            let url = row.activitySectionTypeUrl
            url = url.replace('{entityId}', row.entityId)
            url = url.replace('{activitySectionId}', row.activitySectionId)
            formatSectionLink = <Link to={ url }>{ row.activitySectionName }</Link>
        }
    
        return formatSectionLink
    }

    formatEntityLink(cell, row) {

        let formatEntityLink = 'Loading...'
        if (cell) {
            let url = row.entityTypeUrl
            url = url.replace('{entityId}', row.entityId)
            formatEntityLink = <Link to={ url }>{ cell }</Link>
        }
    
        return formatEntityLink
    }

    render() {

        let activityReportTable = <div>Select a date range above.</div>

        if (this.props.activities.data.length > 0) {
            activityReportTable = (
                <div>
                <Loadable active={ this.state.loadableState } spinner text='Processing your request...'>
                    <BootstrapTable
                        data={ this.props.activities.data }
                        striped={ true }
                        hover={ true }
                        pagination={ true }
                        search={ true }
                        exportCSV={ true }
                        bordered={ true }
                        >
                    <TableHeaderColumn width="100" isKey={true} hidden dataField="id" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Id</TableHeaderColumn>
                    <TableHeaderColumn width="100" dataField="userName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>User</TableHeaderColumn>
                    <TableHeaderColumn width="100" dataField="activity" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Action</TableHeaderColumn>
                    <TableHeaderColumn width="100" dataField="activitySectionTypeName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Section Type</TableHeaderColumn>
                    <TableHeaderColumn width="100" dataField="activitySectionName" dataFormat={ this.formatSectionLink.bind(this) } dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Section</TableHeaderColumn>
                    <TableHeaderColumn width="100" dataField="entityTypeName" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Entity Type</TableHeaderColumn>                    
                    <TableHeaderColumn width="100" dataField="entityName" dataFormat={ this.formatEntityLink.bind(this) } dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Entity</TableHeaderColumn>                    
                    <TableHeaderColumn width="100" dataField="createdAt" dataSort={ true } filter={ { type: 'TextFilter', delay: 50 } }>Date</TableHeaderColumn>
                    </BootstrapTable>
                </Loadable>
                </div>
            )
        }

        return (
            <div>
                <div>
                    <PanelGroup>
                        <Panel header="Report Options">
                            <Form>
                                <FormGroup>
                                    <Col sm={ 2 } componentClass={ ControlLabel }>Start Date:</Col>
                                    <Col sm={ 4 }>
                                    <FormGroup validationState={ this.getStartDateValidationState() }>
                                        <DatePicker id="startDate" dateFormat="YYYY-MM-DD" value={ this.state.startDate } onChange={ this.onStartDateChanged.bind(this) }/>
                                    </FormGroup>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col sm={ 2 } componentClass={ ControlLabel }>End Date:</Col>
                                    <Col sm={ 4 }>
                                    <FormGroup validationState={ this.getEndDateValidationState() }>
                                        <DatePicker id="endDate" dateFormat="YYYY-MM-DD" value={ this.state.endDate } onChange={ this.onEndDateChanged.bind(this) }/>
                                    </FormGroup>
                                    </Col>
                                </FormGroup>
                            </Form>
                            <div style={{ float: 'right' }}>
                                <Button bsStyle="success" onClick={ this.runActivityReport.bind(this) }><i aria-hidden="true"></i>Run Report</Button>
                            </div>
                        </Panel>
                    </PanelGroup>
                </div>
                <div className="clearfix"></div>
                <Collapsible title="Activity Report" content={ activityReportTable } />
            </div>
        )   
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/activityreport.js